import orderBy from 'lodash.orderby';

type Orders = 'asc' | 'desc';

export const sortBy = (array: Array<any>, sortKey: string, orders: Orders) => {
  /**
   * ALl items with the property will be ordered
   */
  const leadingItems: any[] = [];

  /**
   * ALl items without the property will append to the end
   */
  const trailingItems: any[] = [];

  array.forEach((item) => {
    if (item[sortKey]) {
      leadingItems.push(item);
    } else {
      trailingItems.push(item);
    }
  });

  /**
   * Strings are compared lowercased so that ordering is alphabetical rather than
   * codepoint-based (otherwise every capitalised value sorts before every lowercase one).
   */
  const iteratee = (item: (typeof array)[number]) => {
    const value = item[sortKey];

    return typeof value === 'string' ? value.toLowerCase() : value;
  };

  return [...orderBy(leadingItems, [iteratee], [orders]), ...trailingItems];
};
